<template>
    <div>
	    <div id="entitySkillPopover" class="legends-popover entity_skill_popover"></div>
        <b-popover ref="creditProgressPopover" container="entitySkillPopover" :target="creditProgressTargetId" :show.sync="$parent.showStreamCreditProgressPopup" :no-fade="true" triggers="click" :placement="'right'">
            <template v-slot:title>
			    <div class="header-content-row program">
			       <span class="title"> Required {{headerLabel}} as of {{lastUpdatedDateTime(progress)}} </span>
				    <button class="btn_close" aria-label="close" @click="closeCreditProgressPopup">
                        <span class="ic-close"></span>
                    </button>
				</div>
            </template>

            <div class="text-center"><span class="title"><strong>{{title}}</strong></span></div>

            <template v-show="isPieChartGenerated">
                <div class="popup_grph">
                    <div class="skill_chart program_credit" id="creditProgressChart"></div>
                    <div class="skilllegend_detail">
                        <div class="status_row"><span class="lg_blc transferred"></span>Transferred {{legendSuffix}}</div>
                        <div class="status_row"><span class="lg_blc completed"></span>Completed {{legendSuffix}}</div>
                        <div class="status_row"><span class="lg_blc in_progress"></span>In Progress {{legendSuffix}}</div>
                        <div class="status_row"><span class="lg_blc in_the_plan"></span>In the Plan {{legendSuffix}}</div>
                        <div class="status_row"><span class="lg_blc missing"></span>Missing {{legendSuffix}}</div>
                    </div>
                </div>
            </template>
			  <div class="popup-footer">
			    <div class="updated_time">
                    <span>Current Date {{currentDateTime()}}</span>
                </div>

                <div class="updated_time">
                    <span>Last Calculated On {{lastUpdatedDateTime(progress)}}</span>
                </div>

                <div class="calculate_btn">
                    <button class="btn btn-primary" @click="recalculateCreditProgress">Re-calculate now</button>
                </div>
			  </div>

            <div class="loading-spinner">
                <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                    <div class="text-center" style="color: #FFF; overflow: hidden;">
                        <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                    </div>
                </b-modal>
            </div>
        </b-popover>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import moment from 'moment'
  import { PACKAGE } from '../../../package_constants'
  import * as d3 from 'd3'

  export default {
    name: 'program-guide-credit-progress',
    props: ['title', 'programId', 'streamId', 'creditProgressTargetId'],
    data: () => {
      return {
        progress: null,
        isPieChartGenerated: false
      }
    },

    mounted () {
      this.loadCreditProgress(false)
    },

    updated () {
      this.$nextTick(() => {
        if (this.progress) {
          if (this.isShowCourseProgressEnabled) {
            let colorScale = {
              'transferred courses': '#56b5e8',
              'completed courses': '#5c8c43',
              'in progress courses': '#aac76b',
              'scheduled courses': '#f5b318',
              'courses needed': '#cf7908'
            }
            this.generatePieChart(this.progress.courseValues, colorScale, 'creditProgressChart')
          } else {
            let colorScale = {
              'transferred': '#56b5e8',
              'completed': '#5c8c43',
              'in progress': '#aac76b',
              'scheduled': '#f5b318',
              'credits needed': '#cf7908'
            }
            this.generatePieChart(this.progress.values, colorScale, 'creditProgressChart')
          }
        }
      })
    },

    methods: {
      ...mapActions([
        'loadProgramCreditProgress'
      ]),

      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },

      closeCreditProgressPopup () {
        this.$parent.selectedStream = null
        this.$parent.creditProgressTargetId = ''
        this.$parent.showStreamCreditProgressPopup = false
      },

      loadCreditProgress (isRecalculate) {
        this.showLoader()
        this.isPieChartGenerated = false
        this.loadProgramCreditProgress({streamId: this.streamId, programId: this.programId, recalculate: isRecalculate}).then(res => {
          this.progress = res
          setTimeout(() => {
            this.hideLoader()
          }, 500)
        })
      },

      generatePieChart (data, colorScale, elementId) {
        $('#' + elementId).empty()
        var pieChartContainerHeight = 250
        var pieChartInnerRadius = 60
        var width = pieChartContainerHeight
        var height = pieChartContainerHeight
        var radius = pieChartContainerHeight / 2

        var canvas = d3.select('#' + elementId).append('svg')
                     .data([data]).attr('width', width).attr('height', height).append('g')
                     .attr('transform', 'translate(' + radius + ',' + radius + ')')

        var arc = d3.arc()
                  .outerRadius(radius)
                  .innerRadius(pieChartInnerRadius)

        var pie = d3.pie()
                  .value(function (d) { return d.value }).sort(null)

        var arcs = canvas.selectAll('.arc')
                   .data(pie(data))
                   .enter().append('g')
                   .attr('class', 'arc')

        arcs.append('path')
            .attr('d', arc)
            .style('fill', function (d, i) { return colorScale[d.data.label] })

        arcs.append('text')
            .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
            .style('font', 'bold 12px Arial')
            .style('fill', '#fff')
            .style('cursor', 'default')
            .attr('text-anchor', 'middle')
            .text(function (d) { return d.data.value })

        this.isPieChartGenerated = true
      },

      changeMillisToDate (millis, format) {
        return DateTime.fromMillis(millis, {zone: 'utc'}).toFormat(format)
      },

      lastUpdatedDateTime (progress) {
        return (progress) ? this.changeMillisToDate(progress.lastUpdatedTime, 'MM/dd/yyyy @ hh:mm a') : ''
      },

      currentDateTime (progress) {
        let millis = moment().valueOf()
        if (progress && progress.currentTime) {
          millis = progress.currentTime
        }
        return this.changeMillisToDate(millis, 'MM/dd/yyyy (hh:mm a)')
      },

      recalculateCreditProgress () {
        this.loadCreditProgress(true)
      }
    },

    computed: {
      ...mapState({
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      headerLabel () {
        return this.isShowCourseProgressEnabled ? 'Courses' : 'Credits'
      },
      legendSuffix () {
        return this.isShowCourseProgressEnabled ? 'Courses' : ''
      },
      isShowCourseProgressEnabled () {
        let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
        console.log('progressViewFeature: ', progressViewFeature)
        if (progressViewFeature && progressViewFeature.enabled) {
          let flags = progressViewFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgressOnOverall') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isShowCreditProgressEnabled () {
        let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
        console.log('progressViewFeature: ', progressViewFeature)
        if (progressViewFeature && progressViewFeature.enabled) {
          let flags = progressViewFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCreditProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideStreamCreditProgress.vue